import http from '@/plugs/httpServer';
import { serverName } from '@wj/common';
let feather_campus= "feather-campus"

// 简历列表查询
export function getResumeList(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/resume/pageResume`,
        data: data,
    })
}
// 获取简历状态
export function getState(data: object) {
    return http({
        method: 'GET',
        url: `${feather_campus}/deliver/getDelState`,
        params: data,
    })
}
// 获取简历详情
export function getResumeDetail(data: object) {
    return http({
        method: 'GET',
        url: `${feather_campus}/resume/getResumeById`,
        params: data,
    })
}
// 岗位列表
export function getPosition(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/job/getAllJobs`,
        data: data,
    })
}
// 单列表查询
export function getByPage(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/pageDeliver`,
        data: data,
    })
}
// 面试结果
export function getDelState(data: object) {
    return http({
        method: 'GET',
        url: `${feather_campus}/deliver/getDelState`,
        params: data,
    })
}
// 面试结果录入
export function evaluateDelivers(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/evaluateDelivers`,
        data: data,
    })
}
// 面试结果通知
export function sendResults(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/sendResults`,
        data: data,
    })
}

// 预约通知
export function sendCheckinTip(data: object) {
    return http({
        method: 'POST',
        url: `${feather_campus}/deliver/sendCheckinTip`,
        data: data,
    })
}
